import { computed, ref } from "#imports";
export function useModalSteps({ numberOfSteps, initialStep = 0 }) {
  const currentStep = ref(initialStep);
  const nextStep = () => {
    if (currentStep.value < numberOfSteps - 1) {
      currentStep.value++;
    }
  };
  const prevStep = () => {
    if (currentStep.value > 0) {
      currentStep.value--;
    }
  };
  const resetSteps = () => {
    currentStep.value = 0;
  };
  const isLastStep = computed(() => currentStep.value === numberOfSteps - 1);
  return {
    currentStep,
    isLastStep,
    nextStep,
    prevStep,
    resetSteps
  };
}
